<template>
  <!-- 国祯企业下面项目-工资申报表 -->
  <div class="wageGz">
      <el-row class="content-head">
        <el-col :span="24">
            <div class="grid-content bg-purple-dark">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
                <el-breadcrumb-item>农民工工资申报表</el-breadcrumb-item>
            </el-breadcrumb>
            </div>
        </el-col>
      </el-row>
      <div class="wage-con">
          <div class="wage-head">
            <div style="display:flex;">
                <el-page-header @back="goBack" content="" style="width:8vw;align-items: center;"></el-page-header>
                <el-input placeholder="请输入单位名称" v-model="search.name" clearable style="margin-right:1vw;"></el-input>
                <el-date-picker
                    v-model="search.applyMonth"
                    type="month"
                    @change="doFilter"
                    value-format="yyyy-MM"
                    placeholder="选择月份">
                </el-date-picker>
                <el-button type="primary" @click="doFilter" style="margin-left:1vw;">查询</el-button>
            </div>
            <div style="display:flex;">
            </div>
          </div>
          <div class="wage-main">
              <el-table
                :data="listData"
                stripe
                border
                height="100%"
                style="width: 100%;"
                :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
                >
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <!-- <el-table-column label="序号" width="100">
                    <template slot-scope="scope">
                    <span>{{ scope.row.index }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column type="index" width="100">
                </el-table-column>
                <el-table-column label="月份">
                    <template slot-scope="scope">
                    <span>{{ scope.row.applyMonth }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="申报单位">
                    <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="申请人员">
                    <template slot-scope="scope">
                    <span>{{ scope.row.applyPerson }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="人员数量">
                    <template slot-scope="scope">
                    <span>{{ scope.row.applyPersonNum }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="申报时间">
                    <template slot-scope="scope">
                    <span>{{ scope.row.applyDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button type="text" @click="toInfo(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
              </el-table>
              <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                ></el-pagination> -->
          </div>
      </div>
      <!-- <el-dialog
        title="选择时间"
        :visible.sync="dialogTime"
        width="30%">
        <el-form
            :model="addForm"
            ref="addForm"
            label-width="100px"
            :label-position="labelPosition"
            >
            <el-form-item label="月份：">
                <el-date-picker v-model="addForm.applyMonth" type="month" value-format="yyyy-MM" placeholder="选择月份"></el-date-picker>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogTime = false">取 消</el-button>
            <el-button type="primary" @click="getExportFun">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="导入数据"
        :visible.sync="dialogUpload"
        width="30%">
        <el-form
            :model="uploadData"
            ref="addForm"
            label-width="100px"
            :label-position="labelPosition"
            >
            <el-form-item label="月份：">
                <el-date-picker v-model="uploadData.applyMonth" type="month" value-format="yyyy-MM" placeholder="选择月份"></el-date-picker>
            </el-form-item>
            <el-upload
                class="upload-demo"
                ref="upload"
                :action="uploadUrl"
                :headers="uploadHead"
                :data="uploadData"
                :before-upload="beforeAvatarUpload"
                :on-success="handleAvatarSuccess"
                :show-file-list="false">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
        </el-form>
      </el-dialog>
      <el-dialog title="提示" :visible.sync="tipVis" width="30%">
            <el-table ref="singleTable" :data="tipList" style="width: 100%">
                <el-table-column type="index" label="序号" width="80" ></el-table-column>
                <el-table-column property="status" label="状态" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status=='1'" style="color:#F56C6C;">失败</span>
                        <span v-else-if="scope.row.status=='0'" style="color:#67C23A;">成功</span>
                        <span v-else></span>
                    </template>
                </el-table-column>
                <el-table-column property="reason" label="信息">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status=='1'" style="color:#F56C6C;">{{scope.row.reason}}</span>
                        <span v-else-if="scope.row.status=='0'" style="color:#67C23A;">{{scope.row.reason}}</span>
                        <span v-else>{{scope.row.reason}}</span>
                    </template>
                </el-table-column>
            </el-table>
      </el-dialog> -->
      <!-- 申报 -->
        <!-- <el-dialog
                :title="dialogTitle"
                :visible.sync="salaryFormVisible"
                center
                width="30%"
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
              >
                <el-form
                  :model="salaryForm"
                  label-width="200px"
                  ref="salaryForm"
                  label-position="right"
                  :rules="rules"
                >
                  <el-form-item label="开户行:" prop="bank">
                    <el-input v-model="salaryForm.bank" placeholder="请输入开户行" @input="change($event)" autocomplete="off" style="width:217px"></el-input>
                  </el-form-item>
                  <el-form-item label="行号:" prop="lineNumber">
                    <el-input v-model="salaryForm.lineNumber" placeholder="请输入行号" @input="change($event)" autocomplete="off" style="width:217px"></el-input>
                  </el-form-item>
                  <el-form-item label="卡号:" prop="bankCard">
                    <el-input v-model="salaryForm.bankCard " placeholder="请输入卡号" @input="change($event)" autocomplete="off" style="width:217px"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号:" prop="phone">
                    <el-input v-model="salaryForm.phone " autocomplete="off" @input="change($event)" placeholder="请输入手机号" style="width:217px"></el-input>
                  </el-form-item>
                  <el-form-item label="实发工资（元）:" prop="money">
                    <el-input v-model="salaryForm.money " type="number" autocomplete="off" @input="change($event)" placeholder="请输入实发工资"  style="width:217px"></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="salaryFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="sumbitAddRow('salaryForm')">确 定</el-button>
                </div>
              </el-dialog> -->
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
export default {
    data(){
        return{
            groupId:'',
            search:{
                applyMonth:util.myTime.getCurMonth(),
                name:'',
            },
            listData:[],
            dataText:'数据加载中...',
            // currentPage: 1,
            // pageSize: 10,
            // totalItems: 0,
            // dialogTime:false,
            // labelPosition:'right',
            // addForm:{
            //     applyMonth:util.myTime.getCurMonth(),
            // },
            // uploadUrl:myHttp.importSalaryExcelShot,
            // uploadHead: {
            //     accessToken: util.session.get('token')
            // },
            // uploadData: {
            //     applyMonth: '',
            //     projectId: '',
            //     userId:'',
            // },
            // dialogUpload:false,//导入弹出框
            // tipVis:false, //导入数据提示框
            // tipList:[],
            // salaryFormVisible:false,
            // salaryForm:{

            // },
            // dialogTitle:'申报工资',
            // rules:{}
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        // this.uploadData.projectId = this.groupId
        // this.uploadData.userId = util.session.get('user').id
        this.getData()
    },
    methods:{
        //过滤
        doFilter(){
            this.getData()
        },
        //
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage()
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData()
        },
        //获取数据
        getData(){
            var that = this
            this.search.projectId = this.groupId
            // this.search.pageNum = this.currentPage
            // this.search.pageSize = this.pageSize
            myHttp.selectApplyListByProjectId(this.search).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.entity||[]
                    // for(var i=0;i<list.length;i++){
                    //     list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                    // }
                    that.listData = list
                    // that.totalItems = resp.data.data.pageInfo.total||0
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },

        //导出表格
        // exportWorker(){
        //     this.dialogTime = true
        //     this.addForm.applyMonth = util.myTime.getCurMonth()
            
        // },
        // getExportFun(){
        //     this.dialogTime = false
        //     var token = util.session.get('token')
        //     window.open(myHttp.exportTeamsApplyDetailByConditions+'?projectId='+this.groupId+'&applyMonth='+this.addForm.applyMonth+'&accessToken='+token)
            
        // },
        // change(e){
        //   this.$forceUpdate()
        // },
        
    
        //导入
        // inTable(){
        //     this.dialogUpload = true
        // },
        // beforeAvatarUpload(file){
        //     if(this.uploadData.applyMonth==''){
        //         this.$message.error('请选择时间')
        //         return false
        //     }else{
        //         this.loading = this.$loading({
        //           lock: true,
        //           text: 'Loading',
        //           spinner: 'el-icon-loading',
        //           background: 'rgba(0, 0, 0, 0.7)'
        //       });
        //         return true
        //     }
        // },
        // handleAvatarSuccess(res,file){
        //     console.log(res)
        //     if(res.code=='200'){
        //         this.getData()
        //         this.loading.close()
        //         this.dialogUpload = false
        //         this.tipVis = true
        //         this.tipList = res.data.list||[]
        //     }else{
        //         this.loading.close()
        //         this.$message.error(res.msg)
        //     }
        // },
        // 申报
        // handleEdit(index,row){
        //   console.log(row)
        //   this.salaryFormVisible =true
        //   this.salaryForm.userId = util.session.get('user').id
        //   this.salaryForm.idcard = row.idcard
        //   this.salaryForm.attendDays  = row.attendDays 
        //   this.salaryForm.projectId = this.groupId
        //   this.salaryForm.personName = row.personName
        //   this.salaryForm.applyMonth = row.applyMonth
        //   this.salaryForm.phone = row.phone
        //   this.salaryForm.bank  = row.bank 
        //   this.salaryForm.money = row.money
        //   this.salaryForm.lineNumber  = row.lineNumber 
        //   this.salaryForm.bankCard = row.bankCard

        // },
        //保存
        // sumbitAddRow(formName){
        //     var that = this;
        //     this.$refs[formName].validate((valid) => {
        //         if (valid) {
        //             myHttp.insertSalaryShot(that.salaryForm).then(function(resp){
        //                 if(resp.data.code=="200"){
        //                 that.$message.success('申报成功成功');
        //                 that.salaryFormVisible = false;
        //                 that.getData();
        //                 }else{
        //                 that.$message.error(resp.data.msg);
        //                 }
        //             });
                
        //         }
        //     });
        // },

        //查看
        toInfo(row){
            var applyFormId = row.applyFormId
            var that = this
            myHttp.getApplyPdf({
                applyFormId:applyFormId
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var url = resp.data.data.applyPhotoUrl
                    if(url){
                        util.session.set('url', url)
                        that.$router.push('/wageInfo/'+applyFormId)
                    }
                }else{
                    that.$message.error(resp.data.msg)
                }
            })
        },

        //返回
        goBack(){
            this.$router.go(-1)
        },
    }
}
</script>

<style scoped>
    .wageGz{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    .wage-con{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        background: #fff;
        border-radius: 6px;
    }
    .wage-head{
        width: 100%;
        height: 7vh;
        position: relative;
        border-bottom: 2px solid #409EFF;
        padding: 0 1vw;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        justify-content:space-between;
    }
    .wage-main{
        width: 100%;
        height: calc( 100% - 15vh );
        position: relative;
    }
</style>

<style>
    @import '../../assets/css/common.css';
    .tips{
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
    }
    .wageGz .el-form-item__content{
        text-align: left;
    }
    .wageGz .el-dialog__footer{
        text-align: center;
    }
</style>